/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

require("vanilla-cookieconsent/dist/cookieconsent.css")
require("./src/scss/components/_cookie-consent.scss")

const { initializeCookieConsent } = require("./src/services/cookieConsent")

exports.onClientEntry = () => {
  initializeCookieConsent()
}

exports.shouldUpdateScroll = () => {
  document.body.scrollTop = 0
}
